import AppRoutes from './routes'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material'
import { LightTheme } from './themes'
import './global.css'
import { UserProvider } from './contexts/UserContext';

const cssVars = (theme) => ({
  ':root': {
    '--primary-main': theme.palette.primary.main,
    '--primary-light': theme.palette.primary.light,
    '--primary-dark': theme.palette.primary.dark,
    '--secondary-main': theme.palette.secondary.main,
    '--bg-default': theme.palette.background.default,
    '--bg-paper': theme.palette.background.paper,
    '--text-primary': theme.palette.text.primary,
    '--text-secondary': theme.palette.text.secondary,
    '--error-main': theme.palette.error.main,
    '--success-main': theme.palette.success.main,
    '--warning-main': theme.palette.warning.main,
    '--info-main': theme.palette.info.main,
    '--action-hover': theme.palette.action.hover,
    '--divider': theme.palette.divider,
  },
})

function App() {
  return (
    <ThemeProvider theme={LightTheme}>
      <CssBaseline />
      <GlobalStyles styles={cssVars} />
      <BrowserRouter>
        <UserProvider>
          <AppRoutes />
        </UserProvider>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App